import { useParams } from 'react-router-dom';
import React, { useState } from 'react';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';

const FeetFirstStories = () => {
  const { id } = useParams();
  const [voucher, setVoucher] = useState('');
  const [verified, setVerified] = useState(false);
  const [discount, setDiscount] = useState(0);
  const [paymentOption, setPaymentOption] = useState('');

  const deal = {
    id,
    title: "Maldives Romantic Retreat",
    location: "Maldives",
    description: "Luxury stay with sunset views and private pool.",
    dealPrice: 1000,
    offerPrice: 800,
    business: {
      name: "Oceanic Hotels",
      type: "Hotel",
      contact: "contact@oceanichotels.com",
      location: "Malé, Maldives"
    },
    userReviews: 120,
    image: `/api/downloads/thinktravel/deals/${id}.png`,
  };

  const handleVerify = () => {
    if (voucher === 'LOVE50') {
      setVerified(true);
      setDiscount(50); // 50% off example
    } else {
      setVerified(false);
      setDiscount(0);
    }
  };

  const finalPrice = discount > 0 ? deal.offerPrice * (1 - discount / 100) : deal.offerPrice;

  const [voucherVisible, setVoucherVisible] = useState(false);

  const handleBookNow = () => {
    if (paymentOption) {
      setVoucherVisible(true);
    } else {
      alert('Please select a payment option before booking.');
    }
  };

  const handleDownloadPDF = async () => {
    const input = document.getElementById('voucherSection');
    const canvas = await html2canvas(input, { scale: 2 });
    const imgData = canvas.toDataURL('image/png');

    const pdf = new jsPDF('p', 'mm', 'a4');
    const imgProps = pdf.getImageProperties(imgData);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

    pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
    pdf.save(`${deal?.dealTitle || "voucher"}.pdf`);
  };


  return (
    <div className="text-blue-600 p-6 max-w-4xl mx-auto bg-white">
      
    </div>
  );
};

export default FeetFirstStories;
